export const ERROR = "error";
export const MESSAGE_ERROR = "Los parámetros de tu solicitud no son válidos";